/** ###########################################################################################################
 ###########################################################################################################

 Modals Functionality

 ----------------------------------------------------------------------------------------------------------
 Dependency:
 - Colorbox modal plugin ( v1.6.4 )

 This functionality is used as abstraction layer between any third party library for modals
 and usage of modals in our store/templates.

 That way we can easy replace any library without readjustement in all .js/.jsp files.

 ----------------------------------------------------------------------------------------------------------
 Usage:
 - Attach "data-modal-title" and "data-modal-content" attributes to button that triggers modal opening
 - Open: Inside .js trigger modal open function with clicked element passed as parameter => "$modal.open(clickedEl)"
 - Close: Inside .js trigger modal close function without any parameters => "$modal.close()""

 */

// ###########################################################################################################
// Colorbox library global settings
const COLORBOX = {
	className: 'isHidden',
	opacity: 0.85,
	close: false,
	fixed: true,
	reposition: false,
	transition: 'none',
	top: '0',
	left: '0',
	data: true,
	title() {
		// Return title element
		return '<h2 class="headline" id="modalTitle"><span class="headline-text"></span></h2>';
	},
	html() {
		// Get modal content data from element
		const htmlContent = $.colorbox.element()[0].dataset.modalContent;
		// If value has is ID of the element, return this as $ object
		if (htmlContent && htmlContent[0] === '#') {
			// Copy content with all events ( true flag in clone method )
			const contentCopy = $(htmlContent).clone(true);
			return $(contentCopy);
		}
		// Else return it as string wrapped in DIV container
		return htmlContent ? `<div><p>${htmlContent}</p></div>` : '';
	},

	onOpen() {},

	onLoad() {},

	onComplete() {
		const colorBoxModal = document.querySelectorAll('#colorbox')[0];
		const cboxContent = colorBoxModal.querySelector('#cboxContent');
		const cboxTitle = cboxContent.querySelector('#cboxTitle');
		const { modalTitle } = $.colorbox.element()[0].dataset;
		const modalLabel = $.colorbox.element()[0].getAttribute('data-label');
		const modalCloseBtn = colorBoxModal.querySelector('#cboxClose');
		const main = document.querySelector('main');
		let cboxDescription;

		// Remove some of #colorbox default styles
		colorBoxModal.style.width = '';
		colorBoxModal.style.height = '';
		// remove unnecessary elements
		if (colorBoxModal.querySelector('#cboxSlideshow')) {
			colorBoxModal.querySelector('#cboxPrevious').remove();
			colorBoxModal.querySelector('#cboxNext').remove();
			colorBoxModal.querySelector('#cboxSlideshow').remove();
		}

		// Hidden another content for accessibility API
		main.setAttribute('aria-hidden', 'true');

		if (modalTitle) {
			colorBoxModal.setAttribute('aria-labelledby', 'modalTitle');
		}

		if (cboxDescription) {
			colorBoxModal.setAttribute('aria-describedby', cboxDescription.id);
		}

		if (modalLabel) {
			colorBoxModal.setAttribute('aria-label', modalLabel);
		}

		colorBoxModal.setAttribute('aria-modal', true);

		if (modalCloseBtn) {
			modalCloseBtn.setAttribute('aria-label', 'Close Dialog');
		}

		const svgModalCloseBtn = document.createElement('svg');
		svgModalCloseBtn.setAttribute('role', 'img');
		svgModalCloseBtn.setAttribute('id', 'icon-close-lg');
		svgModalCloseBtn.setAttribute('class', 'icon-sprite icon-close-lg');
		svgModalCloseBtn.setAttribute('aria-hidden', 'true');
		svgModalCloseBtn.setAttribute('focusable', 'false');
		modalCloseBtn.appendChild(svgModalCloseBtn);

		ACC.utils.addModalFocusTrap();

		// Remove title inline styles
		cboxTitle.removeAttribute('style');

		// Remove title if content is not present
		if (modalTitle) {
			// Set title if available ( attached as data attribute to clicked element )
			cboxTitle.querySelector('.headline-text').textContent = modalTitle;
		} else if ($.colorbox.arguments && typeof $.colorbox.arguments[0].title === 'string') {
			// Set title if passed as argument while calling modals library without clicked element
			cboxTitle.innerHTML = `<h2 class="headline" id="modalTitle">
              <span class="headline-text">${$.colorbox.arguments[0].title}</span>
            </h2>`;
		} else {
			// Remove title DOM NODE if title is undefined
			cboxTitle.parentNode.removeChild(cboxTitle);
		}

		// Remove styles from one of inner divs
		colorBoxModal.querySelector('#cboxMiddleRight').removeAttribute('style');
		colorBoxModal.querySelector('#cboxMiddleLeft').removeAttribute('style');

		// Remove style attribute on #cboxWrapper & #cboxContent
		colorBoxModal.querySelector('#cboxWrapper').removeAttribute('style');
		cboxContent.removeAttribute('style');
		cboxContent.querySelector('#cboxLoadedContent').removeAttribute('style');

		// Remove hidden class ( change modal state from hidden to visible )
		setTimeout(() => {
			colorBoxModal.classList.remove('isHidden');
		}, 200);
	},

	onCleanup() {
	},

	onClosed() {
		// Show another content for accessibility API
		document.querySelector('main').removeAttribute('aria-hidden');
	},
};

// ###########################################################################################################
// Our functionality written as $modal class with predefined methods
// for opening and closing modal windows

// eslint-disable-next-line no-unused-vars
const $modal = (function () {
	// Open modal
	const open = function (clickedEl, content) {
		// In case of additional content that should be passed
		// exclude DOM element which brings properties such as
		let options;
		if (clickedEl === null && content) {
			// Concatenate global settings and override with our custom ( jQuery dependency )
			options = $.extend({}, COLORBOX, content);
			// and open modal with defined settings
			return $.colorbox(options);
		}

		if (clickedEl && content) {
			// Concatenate global settings and override with our custom ( jQuery dependency )
			options = $.extend({}, COLORBOX, content);
			// and open modal with defined settings
			return $(clickedEl).colorbox(options);
		}

		// In case of classic usage, just trigger modal library, attach it to DOM element
		// and pass global settings to it.
		// ( IMPORTANT: This element should have title and modal content attached as HTML 5 data attributes
		// data-modal-title and data-modal-content )
		return $(clickedEl).colorbox(COLORBOX);
	};

	// Close modal
	const close = function () {
		// Trigger modal library's internet closing method
		return $.colorbox.close();
	};

	// Return whole $modal functionality as JS Object with public methods
	// open and close mapped to private methods equivalent
	return {
		open,
		close,
	};
}());
